<template>
  <!-- eslint-disable -->
  <div class="container">
    <main class="content">
      <!-- Post Generation Form -->
      <section class="post-generation">
        <div class="prompts_container">
          <div class="text-group-first">
            <span class="type-span">Choose A Post Type</span>
            <select v-model="selectedCategory" class="select">
              <option selected value="Famous Quotes">Famous Quotes</option>
              <option value="Educational Content">Educational Content</option>
              <option value="Seasonal-Holiday Posts">Seasonal/Holiday Posts</option>
              <option value="Engagement Posts">Engagement Posts</option>
              <option value="Fun Facts">Fun Facts</option>
              <option value="Humorous Posts">Humorous Posts</option>
              <option value="Quote of the Day">Quote of the Day</option>
              <option value="Interactive Content">Interactive Content</option>
            </select>
          </div>
          <div class="text-group">
            <span class="type-span">Additional Instructions (not required)</span>
            <textarea v-model="additionalInfo" type="text" class="input-text"
                      placeholder="Provide additional information to further refine the post."></textarea>
          </div>
        </div>
        <b-button variant="success" @click="generatePost" :disabled="loading">
          <span>Generate Post</span>
        </b-button>
      </section>

      <b-modal v-model="showSocialPostModal"
        :title="socialPostModalTitle">
        <div v-if="postingItem">
          <p class="mb-3">{{ socialPostConfirmMessage(postingType) }}</p>
          <div><strong>Review Text: </strong>
            <!-- eslint-disable-next-line -->
            <span v-html="postingItem.text"></span>
          </div>
          <div v-if="postingType === 'instagram' && postingItem.instagram_post" class="mt-3">
            Posted to Instagram on {{ postingItem.instagram_post.front_date }}<br />
            Link: <a :href="'https://www.instagram.com/p/' + postingItem.instagram_post.ig_shortcode"
              target="_blank">https://www.instagram.com/p/{{ postingItem.instagram_post.ig_shortcode }}</a>
          </div>
          <div v-if="postingType === 'facebook' && postingItem.facebook_post" class="mt-3">
            Posted to Facebook on {{ postingItem.facebook_post.front_date }}<br />
            Link: <a :href="'https://www.facebook.com/' + postingItem.facebook_post.post_id"
              target="_blank">https://www.facebook.com/{{ postingItem.facebook_post.post_id }}</a>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="danger" @click="showSocialPostModal = false">Cancel</b-button>
          <b-button variant="success" @click="postSocial(postingItem, postingType)"><b-spinner
              v-if="postingItem.working" small /> Post</b-button>
        </template>
      </b-modal>

      <div class="modal_container review_post_modal_wrapper fade" id="review_post_modal">
        <div class="review_post_modal">
          <span id="modal_close" class="modal_close_icon" @click="fadeOut">&times;</span>
          <div class="modal_content_wrapper">
            <div class="modal_content">
              <div class="post_content">
                <div class="post">
                  <div v-if="loading" class="loading_div">
                    <h2 class="generate">Generating Post!</h2>
                    <b-spinner class="spin" large></b-spinner>
                  </div>
                  <div v-else>
                    <div class="post_text_wrapper">
                      <p id="post_text" class="post_text editable_text" dir="ltr" contenteditable @input="updatePostText" v-html="newPost.text"></p>
                      <br>
                      <p id="post_tags" class="post_tags editable_text" dir="ltr" contenteditable @input="updatePostHashtags" v-html="newPost.hashtags"></p>
                    </div>
                    <div class="post_image_wrapper">
                      <img id="post_image" :src="newPost.imageUrl" alt="" class="post_image" />
                    </div>
                  </div>
                </div>
                <button v-if="!loading" class="edit_post_button" id="edit_post" @click="editPost">Edit</button>
              </div>
              <div v-if="!loading" class="regenrate_buttons_container">
                <b-button variant="success" class="regenerate_btn"  @click="regenerate('image')" :disabled="loadingImage">
                  <b-spinner v-if="loadingImage" small></b-spinner>
                  <span>Regenerate Image</span>
                </b-button>
                <b-button variant="success" class="regenerate_btn"  @click="regenerate('post')" :disabled="loadingPost">
                  <b-spinner v-if="loadingPost" small></b-spinner>
                  <span>Regenerate Post</span>
                </b-button>
              </div>
              <div v-if="!loading" class="social_media_buttons_container">
                <b-button variant="success" class="social_post_btn" @click="postSocial(null, 'facebook')" :disabled="loadingFacebook">
                  <b-spinner v-if="loadingFacebook" small></b-spinner>
                  <span>Post To Facebook</span>
                </b-button>
                <b-button variant="success" class="social_post_btn" @click="postSocial(null, 'instagram')" :disabled="loadingInstagram">
                  <b-spinner v-if="loadingInstagram" small></b-spinner>
                  <span>Post To Instagram</span>
                </b-button>
                <b-button variant="success" class="social_post_btn" @click="postSocial(null, 'instagram', true)" :disabled="loadingFbIg">
                  <b-spinner v-if="loadingFbIg" small></b-spinner>
                  <span>Post To FB & IG</span>
                </b-button>
                <b-button variant="success" class="social_post_btn" @click="postSocial(null, 'google', true)" :disabled="loadingGbp">
                  <b-spinner v-if="loadingGbp" small></b-spinner>
                  <span>Post To Google</span>
                </b-button>
              </div>
            </div>
          </div>
          <button v-if="!loading" class="save_btn" id="save_btn" @click="saveNewPost">Save</button>
        </div>
      </div>

      <!-- Recent Posts -->
      <section v-if="posts.length" class="recent-posts">
        <h2 class="section-title">Recent Posts</h2>
        <div v-for="post in posts" :key="post.date" class="recentPost">
          <div class="post-header">
            <span class="post-title" v-html="post.text"></span>
            <span class="post-title" v-html="post.hashtags"></span>
            <div class="post-buttons">
              <div class="buttonspan">
                <b-button v-if="user.business.facebook_token && user.business.facebook_token.fb_page_id" size="sm"
                  :class="{ 'bg-success': post.facebook_post, 'border-success': post.facebook_post }"
                  class="post-btn mt-2 mr-2 bg-primary border-primary" @click="confirmPostSocial(post, 'facebook')">
                  <span v-if="post.facebook_post">Posted</span><span v-else>Post</span> to Facebook
                </b-button>
                <span v-if="post.facebook_post" class="formatteddate">{{ formattedDate(post) }}</span>
              </div>
              <div class="buttonspan">
                <b-button v-if="user.business.facebook_token && user.business.facebook_token.ig_identifier" size="sm"
                  :class="{ 'bg-success': post.instagram_post, 'border-success': post.instagram_post }"
                  class="post-btn mt-2 mr-2 bg-primary border-primary" @click="confirmPostSocial(post, 'instagram')">
                  <span v-if="post.instagram_post">Posted</span><span v-else>Post</span> to Instagram
                </b-button>
                <span v-if="post.instagram_post" class="formatteddate">{{ formattedInstagramDate(post) }}</span>
              </div>
              <div class="buttonspan">
                <b-button v-if="user.business.location_id" size="sm"
                          :class="{ 'bg-success': post.gbp_post, 'border-success': post.gbp_post }"
                          class="post-btn mt-2 bg-primary border-primary" @click="confirmPostSocial(post, 'google')">
                  <span v-if="post.gbp_post">Posted</span><span v-else>Post</span> to Google
                </b-button>
                <span v-if="post.gbp_post" class="formatteddate">{{ formattedInstagramDate(post) }}</span>
              </div>
            </div>
          </div>
          <img :src="post.imageUrl" alt="Generated Image" class="post-image">
        </div>
        <div class="load-div">
          <button v-if="hasMorePosts"
            class="btn post-btn mt-2 mr-2 bg-primary border-primary btn-secondary btn-lr load-more-btn"
            @click="loadMore">Load
            More</button>
        </div>
      </section>
      <b-modal  content-class="keymodal" v-model="showConnectAlert">
        <p><strong>Important:</strong> Connect Your Social Media Accounts</p>
        <p>To start automating your social media content, please connect your social media accounts.</p>
        <p>Connecting your accounts ensures seamless content creation and scheduling, making your social media management effortless.</p>
        <b-button variant="primary" @click="gotoSettings">Connect Your Accounts</b-button>
      </b-modal>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import { businessLimitForUser } from '@utils/businessLimitsFeature'
import {
  socialPostModalTitle,
  socialPostConfirmMessage,
} from '@utils/socialPostModal'

export default {
  name: 'SocialPosts',
  data() {
    return {
      selectedCategory: 'Famous Quotes',
      additionalInfo: '',
      posts: [],
      postingItem: null,
      postingType: '',
      showSocialPostModal: false,
      socialPostModalTitle,
      loading: false,
      showModal: false,
      newPost: {
        text: '',
        imageUrl: '',
        hashtags: '',
        id: ''
      },
      loadedPostsCount: 2,
      hasMorePosts: true,
      loadingText: false,
      loadingImage: false,
      loadingPost: false,
      loadingFacebook: false,
      loadingInstagram: false,
      loadingGbp:false,
      loadingFbIg: false,
      showConnectAlert: false,
      overPostLimit:false
    };
  },

  computed: {
    formattedDate() {
      return (post) => {
        if (post && post.facebook_post && post.facebook_post.front_date) {
          const date = new Date(post.facebook_post.front_date);
          const options = {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          };
          return date.toLocaleString('en-US', options);
        } else {
          return ''; // Handle cases where the date is not available
        }
      };
    },
    formattedInstagramDate() {
      return (post) => {
        if (post && post.instagram_post && post.instagram_post.front_date) {
          const date = new Date(post.instagram_post.front_date);
          const options = {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          };
          return date.toLocaleString('en-US', options);
        } else {
          return ''; // Handle cases where the date is not available
        }
      };
    },
  },

  mounted() {
    this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
    this.fetchPosts();
    this.loading = false;

    const token = this.$route.params.token;
    if (token) {
      const type = this.$route.params.type;
      const add = this.$route.params.add;

      this.selectedCategory = type;
      this.additionalInfo = add;
      this.generatePost();
    }

    if(this.user.google_accounts && this.user.google_accounts.length >= 1 && !this.user.business.facebook_token && this.user.business.is_social_fusion){
      setTimeout(() => {
        this.showConnectAlert = true;
      }, 250);
    }
  },

  methods: {
    socialPostConfirmMessage,
    gotoSettings() {
      window.location.href = "/business/settings";
    },
    editPost() {
      let elements = document.querySelectorAll('.editable_text');
      console.log(elements);
      elements.forEach(e => {
        if (e.getAttribute('contenteditable') === 'true') {
          e.setAttribute('contenteditable', 'false');
          e.style.border = 'none'
          e.style.padding = '0'
          e.style.whiteSpace = ''
          e.style.minHeight = ''
          e.style.resize = ''
          e.style.overflow = ''
          // Remove keydown event listener
          e.removeEventListener('keydown', this.handleEnterKey);
          document.getElementById('edit_post').innerHTML = "Edit";

        } else {
          e.setAttribute('contenteditable', 'true');
          e.style.border = '1px solid black'
          e.style.padding = '2px'
          e.style.whiteSpace = 'pre-wrap' // Allow multiline and preserve line breaks
          e.style.minHeight = '60px' // Minimum height for multiline editing
          e.style.resize = 'vertical' // Allow vertical resizing
          e.style.overflow = 'auto' // Show scrollbar if content overflows
          e.style.wordWrap = 'break-word' // Break long words
          e.style.overflowWrap = 'break-word' // Break words at appropriate points
          // Add keydown event listener for Enter key
          e.addEventListener('keydown', this.handleEnterKey);
          document.getElementById('edit_post').innerHTML = "Done";
        }
      });
      
      // When disabling edit mode, sync the content back to the model
      const isDisablingEdit = document.querySelector('.editable_text[contenteditable="true"]') === null;
      if (isDisablingEdit) {
        const postTextEl = document.getElementById('post_text');
        const postTagsEl = document.getElementById('post_tags');
        if (postTextEl) {
          this.newPost.text = postTextEl.innerHTML;
        }
        if (postTagsEl) {
          this.newPost.hashtags = postTagsEl.innerHTML;
        }
      }
    },
    handleEnterKey(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        event.stopPropagation();
        
        // Use execCommand for reliable line break insertion
        // This is the standard way browsers handle line breaks in contenteditable
        const success = document.execCommand('insertLineBreak', false, null);
        
        if (!success) {
          // Fallback to manual insertion if execCommand fails
          const selection = window.getSelection();
          if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            range.deleteContents();
            
            // Insert line break
            const br = document.createElement('br');
            range.insertNode(br);
            
            // Ensure br is visible by adding a text node after it if at the end
            if (!br.nextSibling) {
              const textNode = document.createTextNode('');
              br.parentNode.insertBefore(textNode, br.nextSibling);
              range.setStart(textNode, 0);
              range.collapse(true);
            } else {
              range.setStartAfter(br);
              range.collapse(true);
            }
            
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }
        
        // Don't update the model here - we'll sync when editing is done
        // This prevents Vue from re-rendering and resetting the cursor
        return false;
      }
    },
    updatePostText(event) {
      const el = event.target;
      // Don't update the model during editing to prevent Vue re-rendering
      // which causes cursor position to reset
      // The content is already in the DOM, we'll sync it when editing is done
      if (el.getAttribute('contenteditable') === 'true') {
        // Only update if we're not in the middle of handling Enter key
        // The handleEnterKey will update the model
        return;
      }
      
      // Use innerHTML to preserve <br> tags and other formatting
      this.newPost.text = el.innerHTML;
    },
    updatePostHashtags(event) {
      const el = event.target;
      // Don't update the model during editing to prevent Vue re-rendering
      // which causes cursor position to reset
      if (el.getAttribute('contenteditable') === 'true') {
        return;
      }
      
      // Use innerHTML to preserve <br> tags and other formatting
      this.newPost.hashtags = el.innerHTML;
    },
    restoreSelection(el, startOffset, endOffset) {
      const range = document.createRange();
      const sel = window.getSelection();
      range.setStart(el.firstChild, startOffset);
      range.setEnd(el.firstChild, endOffset);
      sel.removeAllRanges();
      sel.addRange(range);
    },
    handleInput(el) {
      this.$nextTick(() => {
        this.placeCaretAtEnd(el);
      });
    },
    placeCaretAtEnd(el) {
      el.focus();
      if (typeof window.getSelection !== "undefined" && typeof document.createRange !== "undefined") {
        let range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        let sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (typeof document.body.createTextRange !== "undefined") {
        let textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
      }else{
        console.error("neither if nor else")
      }
    },
    fadeOut() {
      let duration = 250;
      let element = document.getElementById('review_post_modal');

      element.style.transition = `opacity ${duration}ms`;
      element.style.opacity = 0;

      setTimeout(() => {
        element.style.display = 'none';
        element.classList.remove('show');
      }, duration);
    },
    loadMore() {
      this.loadedPostsCount += 2;
      this.fetchPosts();
    },
    confirmPostSocial(post, type) {
      this.postingItem = post;
      this.postingType = type;
      this.showSocialPostModal = true;
    },

    regenerate(type) {
      if (type === 'text') this.loadingText = true;
      if (type === 'image') this.loadingImage = true;
      if (type === 'post') this.loadingPost = true;

      let action = '';
      const prompt = this.generatePrompt();

      if (type === 'text') {
        action = 'posts/regenerateText';
      } else if (type === 'image') {
        action = 'posts/regenerateImage';
      } else if (type === 'post') {
        action = 'posts/regeneratePost';
      }

      this.$store.dispatch(action, {
        prompt: prompt,
        business_id: this.user.business.id,
        text: this.newPost.text,
        additional_info: this.additionalInfo,
      })
        .then(response => {
          if (response) {
            if (type === 'text' || type === 'post') {
              this.newPost.text = response.text;
              this.newPost.hashtags = response.hashtags;
            }
            if (type === 'image' || type === 'post') {
              this.newPost.imageUrl = response.imageUrl;
            }
          }
        })
        .catch(error => {
          console.error('Error regenerating:', error);
          this.loading = false;
        })
        .finally(() => {
          if (type === 'text') this.loadingText = false;
          if (type === 'image') this.loadingImage = false;
          if (type === 'post') this.loadingPost = false;
        });
    },

    postSocial(post, type, both = false) {
      if (type === 'facebook') this.loadingFacebook = true;
      if (type === 'instagram' && !both) this.loadingInstagram = true;
      if(type === 'google') this.loadingGbp = true;
      if (both) this.loadingFbIg = true;

      post = post || this.newPost;
      this.$set(post, 'working', true); // Use Vue's set method

      const postToSocialMedia = (type) => {
        return this.$store.dispatch('posts/postSocial', {
          type: type,
          post_id: post.id,
          user_id: this.user.id,
          business_id: this.user.business.id
        });
      };

      this.saveNewPost(false)
        .then(() => {
          post = post || this.newPost;
          if (both) {
            // First post to Instagram, then to Facebook
            postToSocialMedia('instagram')
              .then((res) => {
                this.$set(post, 'instagram_post', res.instagram_post);
                return postToSocialMedia('facebook');
              })
              .then((res) => {
                this.$set(post, 'facebook_post', res.facebook_post);
                this.$set(post, 'working', false);
                this.fadeOut();
                this.fetchPosts();
                alert('Post has been successfully posted to Instagram and Facebook!');
                this.showSocialPostModal = false;
              })
              .catch((res) => {
                this.$set(post, 'working', false);
                console.log(res);
              })
              .finally(() => {
                this.loadingFbIg = false;
                this.showSocialPostModal = false;
              });
          } else {
            // Post to the specified type
            postToSocialMedia(type)
              .then((res) => {
                if (type === 'facebook') {
                  this.$set(post, 'facebook_post', res.facebook_post);
                } else if (type === 'instagram') {
                  this.$set(post, 'instagram_post', res.instagram_post);
                }
                this.$set(post, 'working', false);
                this.fadeOut();
                this.fetchPosts();
                alert(`Post has been successfully posted to ${type.charAt(0).toUpperCase() + type.slice(1)}!`);
                this.showSocialPostModal = false;
              })
              .catch((res) => {
                this.$set(post, 'working', false);
                console.log(res);
              })
              .finally(() => {
                if (type === 'facebook') this.loadingFacebook = false;
                if (type === 'instagram' && !both) this.loadingInstagram = false;
                if(type === 'google') this.loadingGbp = false;
                this.showSocialPostModal = false;
              });
          }
        })
        .catch((err) => {
          this.$set(post, 'working', false);
          console.log(err);
        });
    },

    generatePost() {
      if(this.overPostLimit){
        Vue.$toast.open({message: "Sorry, but you have reached your monthly post limit", type: 'error', duration: 5000, position: 'bottom'});
        return
      }
      const prompt = this.generatePrompt();
      this.loading = true;
      let element = document.getElementById('review_post_modal');

      element.style.opacity = 0;
      element.style.display = 'grid';
      element.style.alignItems = 'center';
      element.style.transition = `opacity 250ms`;

      requestAnimationFrame(() => {
        element.style.opacity = 1;
      });

      setTimeout(() => {
        element.classList.add('show');
      }, 250);

      this.$store
        .dispatch('posts/generatePost', {
          prompt: prompt,
          additional_info: this.additionalInfo,
          user_id: this.user.id,
          business_id: this.user.business.id,
        })
        .then((res) => {
          if (res) {
            const reply = res;

            this.newPost = {
              text: reply.text,
              hashtags: reply.hashtags,
              imageUrl: reply.imageUrl,
              date: new Date().toLocaleString(),
            };

            this.updateModalContent();
          }
        })
        .catch((err) => {
          Vue.$toast.open({message: err.response.data.error, type: 'error', duration: 5000, position: 'bottom'});
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateModalContent() {
      // This method updates the modal content with the generated post
      let postTags = document.getElementById('post_tags');
      let postImage = document.getElementById('post_image');
      let postText = document.getElementById('post_text');

      postTags.innerHTML = this.newPost.hashtags;
      postText.innerHTML = this.newPost.text;
      postImage.src = this.newPost.imageUrl;
    },

    saveNewPost(fade=true) {
      return new Promise((resolve, reject) => {
        if (this.newPost.text !== "" && this.newPost.text) {
          this.$store
            .dispatch('posts/savePost', {
              user_id: this.user.id,
              business_id: this.user.business.id,
              hashtags: this.newPost.hashtags,
              text: this.newPost.text,
              image_url: this.newPost.imageUrl,
            })
            .then((res) => {
              this.newPost.id = res.id;
              if (!this.posts.some(post => post.id === this.newPost.id)) {
                  this.posts.unshift(this.newPost);
              }
              resolve(res);
              if(fade){
                this.fadeOut();
                alert('Post has been successfully saved.');
              }
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        } else {
          resolve('done');
        }
      });
    },

    generatePrompt() {
      const date = new Date();
      const today = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
      const Holidays = {
        "2025-01-01": "New Year's Day",
        "2025-01-02": "Science Fiction Day",
        "2025-01-03": "Festival of Sleep Day",
        "2025-01-04": "World Braille Day",
        "2025-01-05": "National Bird Day",
        "2025-01-06": "Epiphany",
        "2025-01-07": "Orthodox Christmas Day",
        "2025-01-08": "Bubble Bath Day",
        "2025-01-09": "Law Enforcement Appreciation Day",
        "2025-01-10": "Houseplant Appreciation Day",
        "2025-01-11": "Learn Your Name in Morse Code Day",
        "2025-01-12": "National Pharmacist Day",
        "2025-01-13": "Make Your Dream Come True Day",
        "2025-01-14": "Dress Up Your Pet Day",
        "2025-01-15": "National Hat Day",
        "2025-01-16": "Nothing Day",
        "2025-01-17": "Ditch New Year's Resolution Day",
        "2025-01-18": "Winnie the Pooh Day",
        "2025-01-19": "Popcorn Day",
        "2025-01-20": "Martin Luther King Jr. Day",
        "2025-01-21": "National Hugging Day",
        "2025-01-22": "Celebration of Life Day",
        "2025-01-23": "Handwriting Day",
        "2025-01-24": "Compliment Day",
        "2025-01-25": "Opposite Day",
        "2025-01-26": "Australia Day",
        "2025-01-27": "Chocolate Cake Day",
        "2025-01-28": "Data Privacy Day",
        "2025-01-29": "Puzzle Day",
        "2025-01-30": "Croissant Day",
        "2025-01-31": "Backward Day",
        "2025-02-01": "National Freedom Day",
        "2025-02-02": "Groundhog Day",
        "2025-02-03": "Golden Retriever Day",
        "2025-02-04": "World Cancer Day",
        "2025-02-05": "National Weatherperson's Day",
        "2025-02-06": "Frozen Yogurt Day",
        "2025-02-07": "Send a Card to a Friend Day",
        "2025-02-08": "Laugh and Get Rich Day",
        "2025-02-09": "Pizza Day",
        "2025-02-10": "Umbrella Day",
        "2025-02-11": "Inventors' Day",
        "2025-02-12": "Darwin Day",
        "2025-02-13": "Galentine's Day",
        "2025-02-14": "Valentine's Day",
        "2025-02-15": "Susan B. Anthony Day",
        "2025-02-16": "Do a Grouch a Favor Day",
        "2025-02-17": "Random Acts of Kindness Day",
        "2025-02-18": "Drink Wine Day",
        "2025-02-19": "Chocolate Mint Day",
        "2025-02-20": "Love Your Pet Day",
        "2025-02-21": "International Mother Language Day",
        "2025-02-22": "Margarita Day",
        "2025-02-23": "Banana Bread Day",
        "2025-02-24": "Tortilla Chip Day",
        "2025-02-25": "Clam Chowder Day",
        "2025-02-26": "Tell a Fairy Tale Day",
        "2025-02-27": "Strawberry Day",
        "2025-02-28": "Public Sleeping Day",
        "2025-03-01": "World Compliment Day",
        "2025-03-02": "Old Stuff Day",
        "2025-03-03": "World Wildlife Day",
        "2025-03-04": "Grammar Day",
        "2025-03-05": "Cheese Doodle Day",
        "2025-03-06": "Dentist's Day",
        "2025-03-07": "Cereal Day",
        "2025-03-08": "International Women's Day",
        "2025-03-09": "Panic Day",
        "2025-03-10": "Mario Day",
        "2025-03-11": "Worship of Tools Day",
        "2025-03-12": "Plant a Flower Day",
        "2025-03-13": "Smart & Sexy Day",
        "2025-03-14": "Pi Day",
        "2025-03-15": "Ides of March",
        "2025-03-16": "Everything You Do is Right Day",
        "2025-03-17": "St. Patrick's Day",
        "2025-03-18": "Awkward Moments Day",
        "2025-03-19": "Let's Laugh Day",
        "2025-03-20": "International Day of Happiness",
        "2025-03-21": "World Poetry Day",
        "2025-03-22": "Goof Off Day",
        "2025-03-23": "Puppy Day",
        "2025-03-24": "Chocolate Covered Raisins Day",
        "2025-03-25": "Tolkien Reading Day",
        "2025-03-26": "Spinach Day",
        "2025-03-27": "World Theatre Day",
        "2025-03-28": "Something on a Stick Day",
        "2025-03-29": "Smoke and Mirrors Day",
        "2025-03-30": "Doctors' Day",
        "2025-03-31": "Crayon Day",
        "2025-04-01": "April Fools' Day",
        "2025-04-02": "Peanut Butter and Jelly Day",
        "2025-04-03": "Find a Rainbow Day",
        "2025-04-04": "Walk Around Things Day",
        "2025-04-05": "Deep Dish Pizza Day",
        "2025-04-06": "Carbonara Day",
        "2025-04-07": "World Health Day",
        "2025-04-08": "Zoo Lovers Day",
        "2025-04-09": "Winston Churchill Day",
        "2025-04-10": "Siblings Day",
        "2025-04-11": "Pet Day",
        "2025-04-12": "Grilled Cheese Sandwich Day",
        "2025-04-13": "Scrabble Day",
        "2025-04-14": "Look Up at the Sky Day",
        "2025-04-15": "Tax Day (USA)",
        "2025-04-16": "Wear Pajamas to Work Day",
        "2025-04-17": "Haiku Poetry Day",
        "2025-04-18": "Columnists Day",
        "2025-04-19": "Garlic Day",
        "2025-04-20": "Volunteer Recognition Day",
        "2025-04-21": "Kindergarten Day",
        "2025-04-22": "Earth Day",
        "2025-04-23": "World Book Day",
        "2025-04-24": "Pig in a Blanket Day",
        "2025-04-25": "DNA Day",
        "2025-04-26": "Pretzel Day",
        "2025-04-27": "Tell a Story Day",
        "2025-04-28": "Superhero Day",
        "2025-04-29": "Dance Day",
        "2025-04-30": "Honesty Day",
        "2025-05-01": "May Day",
        "2025-05-02": "World Tuna Day",
        "2025-05-03": "Lemonade Day",
        "2025-05-04": "Star Wars Day",
        "2025-05-05": "Cinco de Mayo",
        "2025-05-06": "Nurses Day",
        "2025-05-07": "No Pants Day",
        "2025-05-08": "World Red Cross Day",
        "2025-05-09": "Lost Sock Memorial Day",
        "2025-05-10": "Clean Up Your Room Day",
        "2025-05-11": "Twilight Zone Day",
        "2025-05-12": "Limerick Day",
        "2025-05-13": "Apple Pie Day",
        "2025-05-14": "Dance Like a Chicken Day",
        "2025-05-15": "Chocolate Chip Day",
        "2025-05-16": "Love a Tree Day",
        "2025-05-17": "Pack Rat Day",
        "2025-05-18": "No Dirty Dishes Day",
        "2025-05-19": "Devil's Food Cake Day",
        "2025-05-20": "Be a Millionaire Day",
        "2025-05-21": "Talk Like Yoda Day",
        "2025-05-22": "Sherlock Holmes Day",
        "2025-05-23": "Taffy Day",
        "2025-05-24": "Scavenger Hunt Day",
        "2025-05-25": "Towel Day",
        "2025-05-26": "Blueberry Cheesecake Day",
        "2025-05-27": "Sunscreen Day",
        "2025-05-28": "Hamburger Day",
        "2025-05-29": "Paperclip Day",
        "2025-05-30": "Mint Julep Day",
        "2025-05-31": "Macaroon Day",
        "2025-06-01": "Say Something Nice Day",
        "2025-06-02": "Rocky Road Day",
        "2025-06-03": "Repeat Day",
        "2025-06-04": "Cheese Day",
        "2025-06-05": "World Environment Day",
        "2025-06-06": "D-Day Anniversary",
        "2025-06-07": "Chocolate Ice Cream Day",
        "2025-06-08": "Best Friends Day",
        "2025-06-09": "Donald Duck Day",
        "2025-06-10": "Iced Tea Day",
        "2025-06-11": "Corn on the Cob Day",
        "2025-06-12": "Loving Day",
        "2025-06-13": "Sewing Machine Day",
        "2025-06-14": "Flag Day (USA)",
        "2025-06-15": "Nature Photography Day",
        "2025-06-16": "Fresh Veggies Day",
        "2025-06-17": "Eat Your Vegetables Day",
        "2025-06-18": "Go Fishing Day",
        "2025-06-19": "Juneteenth",
        "2025-06-20": "Ice Cream Soda Day",
        "2025-06-21": "International Yoga Day",
        "2025-06-22": "Onion Rings Day",
        "2025-06-23": "Pink Day",
        "2025-06-24": "Fairy Day",
        "2025-06-25": "Catfish Day",
        "2025-06-26": "Chocolate Pudding Day",
        "2025-06-27": "Pineapple Day",
        "2025-06-28": "Paul Bunyan Day",
        "2025-06-29": "Camera Day",
        "2025-06-30": "Meteor Watch Day",
        "2025-07-01": "International Joke Day",
        "2025-07-02": "World UFO Day",
        "2025-07-03": "Stay Out of the Sun Day",
        "2025-07-04": "Independence Day (USA)",
        "2025-07-05": "Workaholics Day",
        "2025-07-06": "Fried Chicken Day",
        "2025-07-07": "World Chocolate Day",
        "2025-07-08": "Video Games Day",
        "2025-07-09": "Sugar Cookie Day",
        "2025-07-10": "Pina Colada Day",
        "2025-07-11": "Cheer Up the Lonely Day",
        "2025-07-12": "Paper Bag Day",
        "2025-07-13": "French Fries Day",
        "2025-07-14": "Mac & Cheese Day",
        "2025-07-15": "Gummi Worm Day",
        "2025-07-16": "Fresh Spinach Day",
        "2025-07-17": "World Emoji Day",
        "2025-07-18": "Caviar Day",
        "2025-07-19": "Daiquiri Day",
        "2025-07-20": "Moon Landing Day",
        "2025-07-21": "Junk Food Day",
        "2025-07-22": "Hammock Day",
        "2025-07-23": "Vanilla Ice Cream Day",
        "2025-07-24": "Cousins Day",
        "2025-07-25": "Wine and Cheese Day",
        "2025-07-26": "Aunt and Uncle Day",
        "2025-07-27": "Scotch Whisky Day",
        "2025-07-28": "Milk Chocolate Day",
        "2025-07-29": "Lasagna Day",
        "2025-07-30": "International Friendship Day",
        "2025-07-31": "Mutt Day",
        "2025-08-01": "Spider-Man Day",
        "2025-08-02": "Ice Cream Sandwich Day",
        "2025-08-03": "Watermelon Day",
        "2025-08-04": "Chocolate Chip Cookie Day",
        "2025-08-05": "Work Like a Dog Day",
        "2025-08-06": "Root Beer Float Day",
        "2025-08-07": "Purple Heart Day",
        "2025-08-08": "International Cat Day",
        "2025-08-09": "Book Lovers Day",
        "2025-08-10": "S'mores Day",
        "2025-08-11": "Mountain Day (Japan)",
        "2025-08-12": "Middle Child Day",
        "2025-08-13": "Left-Handers Day",
        "2025-08-14": "Creamsicle Day",
        "2025-08-15": "Relaxation Day",
        "2025-08-16": "Tell a Joke Day",
        "2025-08-17": "Black Cat Appreciation Day",
        "2025-08-18": "Serendipity Day",
        "2025-08-19": "World Photography Day",
        "2025-08-20": "Lemonade Day",
        "2025-08-21": "Senior Citizens Day",
        "2025-08-22": "Be an Angel Day",
        "2025-08-23": "Ride the Wind Day",
        "2025-08-24": "Pluto Demoted Day",
        "2025-08-25": "Banana Split Day",
        "2025-08-26": "Dog Day",
        "2025-08-27": "Just Because Day",
        "2025-08-28": "Bow Tie Day",
        "2025-08-29": "More Herbs, Less Salt Day",
        "2025-08-30": "Beach Day",
        "2025-08-31": "Trail Mix Day",
        "2025-09-01": "Labor Day (USA)",
        "2025-09-02": "Blueberry Popsicle Day",
        "2025-09-03": "Skyscraper Day",
        "2025-09-04": "Wildlife Day",
        "2025-09-05": "Cheese Pizza Day",
        "2025-09-06": "Read a Book Day",
        "2025-09-07": "Grandparents Day",
        "2025-09-08": "Literacy Day",
        "2025-09-09": "Teddy Bear Day",
        "2025-09-10": "Swap Ideas Day",
        "2025-09-11": "Patriot Day",
        "2025-09-12": "Chocolate Milkshake Day",
        "2025-09-13": "Fortune Cookie Day",
        "2025-09-14": "Cream-Filled Doughnut Day",
        "2025-09-15": "Make a Hat Day",
        "2025-09-16": "Guacamole Day",
        "2025-09-17": "Apple Dumpling Day",
        "2025-09-18": "Cheeseburger Day",
        "2025-09-19": "Talk Like a Pirate Day",
        "2025-09-20": "Punch Day",
        "2025-09-21": "World Gratitude Day",
        "2025-09-22": "Hobbit Day",
        "2025-09-23": "Checkers Day",
        "2025-09-24": "Punctuation Day",
        "2025-09-25": "Comic Book Day",
        "2025-09-26": "Love Note Day",
        "2025-09-27": "Crush a Can Day",
        "2025-09-28": "Good Neighbor Day",
        "2025-09-29": "Coffee Day",
        "2025-09-30": "Hot Mulled Cider Day",
        "2025-10-01": "World Vegetarian Day",
        "2025-10-02": "Name Your Car Day",
        "2025-10-03": "Techies Day",
        "2025-10-04": "Taco Day",
        "2025-10-05": "Do Something Nice Day",
        "2025-10-06": "Mad Hatter Day",
        "2025-10-07": "Frappé Day",
        "2025-10-08": "Pierogi Day",
        "2025-10-09": "Beer and Pizza Day",
        "2025-10-10": "World Mental Health Day",
        "2025-10-11": "Sausage Pizza Day",
        "2025-10-12": "Gumbo Day",
        "2025-10-13": "Train Your Brain Day",
        "2025-10-14": "Dessert Day",
        "2025-10-15": "Grouch Day",
        "2025-10-16": "Boss's Day",
        "2025-10-17": "Pasta Day",
        "2025-10-18": "Chocolate Cupcake Day",
        "2025-10-19": "Evaluate Your Life Day",
        "2025-10-20": "Sloth Day",
        "2025-10-21": "Reptile Awareness Day",
        "2025-10-22": "Nut Day",
        "2025-10-23": "Mole Day",
        "2025-10-24": "Food Day",
        "2025-10-25": "Punk for a Day Day",
        "2025-10-26": "Pumpkin Day",
        "2025-10-27": "Black Cat Day",
        "2025-10-28": "Chocolate Day",
        "2025-10-29": "Internet Day",
        "2025-10-30": "Candy Corn Day",
        "2025-10-31": "Halloween",
        "2025-11-01": "Authors' Day",
        "2025-11-02": "Deviled Egg Day",
        "2025-11-03": "Sandwich Day",
        "2025-11-04": "Candy Day",
        "2025-11-05": "Donut Day",
        "2025-11-06": "Saxophone Day",
        "2025-11-07": "Bittersweet Chocolate Day",
        "2025-11-08": "Cappuccino Day",
        "2025-11-09": "Go to an Art Museum Day",
        "2025-11-10": "Vanilla Cupcake Day",
        "2025-11-11": "Veterans Day",
        "2025-11-12": "Chicken Soup for the Soul Day",
        "2025-11-13": "Kindness Day",
        "2025-11-14": "Pickle Day",
        "2025-11-15": "Clean Out Your Refrigerator Day",
        "2025-11-16": "Fast Food Day",
        "2025-11-17": "Baklava Day",
        "2025-11-18": "Mickey Mouse Day",
        "2025-11-19": "Carbonated Beverage Day",
        "2025-11-20": "Peanut Butter Fudge Day",
        "2025-11-21": "World Television Day",
        "2025-11-22": "Go for a Ride Day",
        "2025-11-23": "Espresso Day",
        "2025-11-24": "Sardines Day",
        "2025-11-25": "Shopping Reminder Day",
        "2025-11-26": "Cake Day",
        "2025-11-27": "Thanksgiving (USA)",
        "2025-11-28": "Black Friday",
        "2025-11-29": "Electronic Greetings Day",
        "2025-11-30": "Mousse Day",
        "2025-12-01": "World AIDS Day",
        "2025-12-02": "Fritters Day",
        "2025-12-03": "Make a Gift Day",
        "2025-12-04": "Cookie Day",
        "2025-12-05": "Ninja Day",
        "2025-12-06": "Microwave Oven Day",
        "2025-12-07": "Pearl Harbor Remembrance Day",
        "2025-12-08": "Brownie Day",
        "2025-12-09": "Pastry Day",
        "2025-12-10": "Human Rights Day",
        "2025-12-11": "Noodle Ring Day",
        "2025-12-12": "Gingerbread House Day",
        "2025-12-13": "Cocoa Day",
        "2025-12-14": "Monkey Day",
        "2025-12-15": "Cupcake Day",
        "2025-12-16": "Chocolate-Covered Anything Day",
        "2025-12-17": "Maple Syrup Day",
        "2025-12-18": "Bake Cookies Day",
        "2025-12-19": "Hard Candy Day",
        "2025-12-20": "Sangria Day",
        "2025-12-21": "Winter Solstice",
        "2025-12-22": "Date Nut Bread Day",
        "2025-12-23": "Festivus",
        "2025-12-24": "Christmas Eve",
        "2025-12-25": "Christmas Day",
        "2025-12-26": "Kwanzaa Begins",
        "2025-12-27": "Fruitcake Day",
        "2025-12-28": "Card Playing Day",
        "2025-12-29": "Pepper Pot Day",
        "2025-12-30": "Bacon Day",
        "2025-12-31": "New Year's Eve"
      }
      const todayHoliday = Holidays[today];
      const categoryPrompts = {
        'Famous Quotes': 'Generate a unique, lesser-known famous quote relevant to business or life. Avoid widely used quotes and do not use unknown or anonymous authors — only well-known individuals. Focus on themes like leadership, innovation, perseverance, teamwork, or success. Format as: "Quote" – Author. No additional text.',
        'Educational Content': 'Create a concise, informative piece of educational content that delivers value. Choose a topic from themes like history, science, technology, health, or personal development. Ensure it covers a different topic than previous content.',
        'Seasonal-Holiday Posts': `Today’s event is ${todayHoliday}. Write a short, thoughtful message that reflects the meaning of ${todayHoliday}. It may be celebratory, reflective, or nostalgic, but keep it sincere and relevant. End with: #${todayHoliday} #Reflection`,
        'Engagement Posts': 'Write a single, open-ended question to spark audience interaction. The topic should be fresh and fall under themes like daily habits, personal goals, favorite hobbies, memorable experiences, or current events.',
        'Fun Facts': 'Share one unique and interesting fun fact. Choose a topic from themes like animals, history, space, the human body, or technology. Avoid common facts and duplication.',
        'Humorous Posts': 'Write one short and funny piece of content — such as a witty one-liner, light joke, or meme-style caption. Focus on themes like workplace humor, daily life, technology, relationships, or puns. Avoid repetition and crude humor.',
        'Quote of the Day': 'Generate one motivational or thought-provoking quote. Use themes like inspiration, wisdom, courage, creativity, or resilience. The quote must be credited to a known author and formatted as: "Quote" – Author. No extra text.',
        'Interactive Content': 'Write a single interactive content idea such as a poll, challenge, trivia question, or mini-survey. Focus on themes like preferences, knowledge, pop culture, or fun participation. Keep it short and engaging.'
      };

      return categoryPrompts[this.selectedCategory];
    },

    fetchPosts() {

      // console.log(this.generatePrompt())

      this.$store
        .dispatch('posts/getPosts', {
          user_id: this.user.id,
          business_id: this.user.business.id,
          limit: this.loadedPostsCount // Limit the number of posts fetched
        })
        .then((res) => {
          if (res.data.length < this.loadedPostsCount) {
            // If fetched posts count is less than requested, assume no more posts available
            this.hasMorePosts = false;
          }
          if (typeof res.can_post === 'boolean') {
            this.overPostLimit = !res.can_post;
          } else {
            const monthlyLimitRaw = this?.user?.business?.limits?.social_fusion_post_limit;
            const monthlyLimit = Number.isFinite(Number(monthlyLimitRaw)) ? Number(monthlyLimitRaw) : 0;
            this.overPostLimit = monthlyLimit > 0 && res.posts_this_month >= monthlyLimit;
          }
          this.posts = res.data.map(post => {
            if(post.image_url)
              post.imageUrl = post.image_url.replace(/\\\//g, '/');
            return post;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>

.prompts_container{
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  @media (max-width: 992px) {
    flex-wrap: wrap;
  }
}

.post-generation {
  align-items: flex-start;
  justify-content: space-between;
  display: grid;
  grid-template-columns: 4fr 1fr;
  //flex-direction: row;
  gap: 1rem;
  width: 100%;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.type-span {
  margin: 5px;
  font-weight: bold;
  color: #868686;
  font-size: 15px;
}

.input-group {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
}

.text-group-first {
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 100%;
  }
}

.text-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.select {
  width: 200px;
  padding: 10px;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
}

.input-text {
  flex-direction: row;
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  height: 100px;
  border-radius: 20px;
  margin-right: 20px;
}

.generate-btn {
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 20px;
}

.generate-btn:disabled {
  background-color: #6c757d;
}

.loader {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loader {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.container {
  display: flex;
}

.content {
  flex: 1;
  padding: 32px;
  @media(max-width: 768px){
    padding: 20px 0;
  }
}

.content-page{
  padding: 0 !important;
}

.post-generation {
  margin-bottom: 32px;
}

.formatteddate {
  margin-top: 5px;
  font-size: 11px;
  font-weight: bold;
  color: red;
}

.buttonspan {
  display: flex;
  flex-direction: column;
}

.input-group {
  display: flex;
  margin-bottom: 16px;
}

.select {
  width: 100% !important;
  margin-right: 20px;
  border: 1px solid #ccc;
  padding: 8px;
  margin-right: 20px;
  padding: 10px;
  border-radius: 10px;
}

.input-text {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px;
  width: 100%;
}

.generate-btn {
  color: white;
  padding: 8px 40px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  margin-top: 30px !important;
}

.recent-posts .section-title {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 16px;
  margin-left: 20px;
  color: gray;
}

.recent-posts {
  background: white;
  padding: 30px;
  border-radius: 20px;
}

.recentPost {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  border: 1px solid lightgray;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 16px;
  @media(max-width: 992px){
    flex-wrap: wrap;
    padding: 3px;
    .post-image{
      order: 1;
      margin-inline: auto;
      width: 50%;
    }
    .post-header{
      order: 2;
    }
  }
}

.post-header {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: 8px;
}

.post-title {
  font-size: 16px;
  margin-left: 20px;
  color: black;
}

.post-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0px;
  margin-left: 30px;
}

.post-btn {
  background-color: #28a745;
  color: white;
  padding: 4px 15px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.spin {
  height: 5rem;
  width: 5rem;
  margin-top: 20%;
  margin-left: 40%;
}

.generate {
  text-align: center;
  color: black;
}

.loading_div {
  height: 300px;
  width: 300px;
}

.post-image {
  margin: 8px 0;
  box-shadow: 3px 3px 10px #d7d7d7;
  width: 30%;
  border-radius: 4px;
}

.post-content {
  color: #6b7280;
  font-size: 14px;
}

.post-date {
  color: #6b7280;
  font-size: 12px;
  margin-top: 4px;
}

.more-link {
  color: #007bff;
  text-decoration: none;
}

.load-more-btn {
  //width: 13%;
}

.load-div {
  justify-content: center;
  display: flex;
  margin-top: 10px;
}


.modal_container {
  min-width: 100vw;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  display: grid;
  justify-content: center;
  align-items: center;
}

.review_post_modal {
  background: #fff;
  height: 100%;
  max-height: 80vh;
  position: relative;
  overflow-y: scroll;
  padding: 1rem;

  .modal_close_icon {
    position: absolute;
    top: .5rem;
    right: .8rem;
    font-weight: 800;
    font-size: 2rem;
    cursor: pointer;
  }
  .modal_content_wrapper{
    padding: 2rem 4rem;
    @media (max-width: 768px){
      padding: 2rem 1rem;
    }
  }
  .modal_content {

    .post_content {
      max-width: 20rem;
      margin-inline: auto;
      margin-bottom: 1rem;
      position: relative;

      @media (max-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: flex-start;
        gap: .5rem;
      }

      .post_text_wrapper {
        background-color: #f2f2f2;
        padding: .5rem .8rem;
        margin-bottom: 5px;

        p {
          margin: 0;
        }
      }

      .post_image_wrapper {
        border: 1px solid gray;

        .post_image {
          width: 100%;
        }
      }

      .edit_post_button {
        border: none;
        background: #284374;
        color: #fff;
        padding: .3rem 1rem;
        border-radius: 4px;
        cursor: pointer;

        @media (min-width: 768px) {
          position: absolute;
          left: 102%;
          top: 0
        }
      }
    }

    .regenrate_buttons_container {
      margin-bottom: .5rem;
      margin-inline: auto;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: .2rem;

      .regenerate_btn {
        margin-inline: .3rem;
        border: none;
        background: #06b050;
        color: #fff;
        padding: .3rem 1.5rem;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
      }
    }

    .social_media_buttons_container {
      margin-inline: auto;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: .2rem;

      .social_post_btn {
        margin-inline: .3rem;
        border: none;
        background: #284374;
        color: #fff;
        padding: .3rem .7rem;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }

  .save_btn {
    border: none;
    background: #284374;
    color: #fff;
    padding: .3rem 1rem;
    border-radius: 4px;
    float: inline-end;
    cursor: pointer;
  }
}

.fade {
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
  display: none;
}

.fade.show {
  opacity: 1;
}
</style>

<style>
.keymodal .modal-body{
  text-align: center !important;
  font-size: 17px !important;
  color: black !important;
}
.keymodal .modal-footer{
  display: none !important;
}
.keymodal .btn{
  font-weight: bold;
  font-size: 17px;
}

@media (min-width: 768px) {

  #review_post_modal{
    padding-top: 4rem
  }
}


</style>
